import { useRef, useEffect, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

// Compact multi-select dropdown with checkboxes. Closes on outside click.
export default function MultiSelect({ label, options, selected, onChange, testid, width = "w-56" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const count = selected.length;
  const norm = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={testid}
        className={`inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] px-4 py-2.5 border transition-colors ${count ? "border-brass text-brass" : "border-line text-vellum-muted hover:text-vellum hover:border-vellum-muted"}`}
      >
        {label}{count > 0 && <span>· {count}</span>}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`${testid}-panel`} data-lenis-prevent className={`absolute z-50 mt-2 ${width} max-h-72 overflow-y-auto overscroll-contain bg-ink-800 border border-line shadow-2xl p-1`}>
          {norm.map((o) => {
            const on = selected.includes(o.value);
            return (
              <button
                key={o.value}
                type="button"
                onClick={() => toggle(o.value)}
                data-testid={`${testid}-opt-${String(o.value).replace(/[^a-zA-Z0-9]/g, "").toLowerCase()}`}
                className="w-full flex items-center gap-2.5 px-3 py-2 text-left font-sans text-sm text-vellum hover:bg-ink-700 transition-colors"
              >
                <span className={`w-4 h-4 border flex items-center justify-center shrink-0 ${on ? "bg-crimson border-crimson" : "border-line"}`}>
                  {on && <Check className="w-3 h-3 text-onaccent" />}
                </span>
                {o.label}
              </button>
            );
          })}
          {count > 0 && (
            <button onClick={() => onChange([])} className="w-full mt-1 px-3 py-2 text-left font-mono text-[10px] uppercase tracking-[0.2em] text-vellum-faint hover:text-crimson transition-colors">
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
